import React, { useEffect, useState } from 'react';
import SubLoading from '../ALL CSS/Loading';

function Auratech_Ads() {
  const [adsData, setAdsData] = useState(null);
  const BASE_URL = 'https://api.auratechacademy.com';
  const [Loading , setLoading ] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}/AD_Section/`);
        const json = await res.json();
        if (json && json.data && json.data.length > 0) {
          setAdsData(json.data[0]); // first item
        }
      } catch (err) {
        console.error('Error fetching ad section:', err);
      }
      finally{
                setLoading(false);

      }
    };

    fetchData();
  }, []);

  if (!adsData) return null; // or a loading spinner

  return (
    <>
    {
        Loading ? (
            <SubLoading/>
        ) :(

       
    <div
      className="widget widget_banner"
      data-overlay="theme"
      data-opacity={9}
      style={{ backgroundImage: 'url(/assets/img/widget/widget-banner-bg.png)' }}
    >
      <div className="widget-banner">
        <h4 className="title">{adsData.heading}</h4>
        <div className="logo">
          <img src={`${BASE_URL}${adsData.add_img}`} alt="Auratech logo" />
        </div>
        <h5 className="subtitle">{adsData.sub_heading}</h5>
        <a href={`tel:${adsData.contact_number}`} className="link">
          +{adsData.contact_number}
        </a>
        <a
          href={adsData.button_link}
          className="th-btn style7"
          target="_blank"
          rel="noopener noreferrer"
        >
          {adsData.button_text} <i className="far fa-arrow-right ms-1" />
        </a>
      </div>
    </div>
     )}
</>
  );
}

export default Auratech_Ads;
